// extracted by mini-css-extract-plugin
export default {"indexDisplay":"IndexDisplay__indexDisplay___1xK9J","indexLabel":"IndexDisplay__indexLabel___WhWqg","indexValue":"IndexDisplay__indexValue___ALU90"};